import { PrintLabelLargePage } from "@/features/print-label/pages/PrintLabelLargePage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/print-label/large")({
	component: PrintLabelLargePage,
});
